export const STORAGE_DEALS_SEARCH_PATH = '/near-me/storage-deals.html';
